import { ACCOUNT_PAGE_SLUG } from '~/common/constants/pageLayout';

import type { UserDetails } from '~/common/types/user';

export const SITTER_APPLICATION_ENTRY_POINT = '/stepper/sitter_application';
export const SITTER_APPLICATION_FALLBACK_URL = `${ACCOUNT_PAGE_SLUG}?completedSitterApplication=true`;

export const getSafeRedirectUrl = (redirectUrl: string | string[] | undefined): string => {
  if (!redirectUrl || Array.isArray(redirectUrl) || !redirectUrl.startsWith('/')) {
    return ACCOUNT_PAGE_SLUG;
  }

  if (redirectUrl.startsWith('//')) {
    return ACCOUNT_PAGE_SLUG;
  }

  return redirectUrl;
};

export const hasRole = (User: UserDetails | null, role: string): boolean => {
  if (!User) {
    return false;
  }

  const { roles } = User;

  if (!roles || !roles.data || !Array.isArray(roles.data)) {
    return false;
  }

  return Boolean(roles.data.find((r) => r.slug === role || r.name === role));
};
